import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M12 15v4.555q-.516.048-1.03.1a5 5 0 0 0-4.46 4.376Q6 28.261 6 34.065q0 2.081.066 3.694a7 7 0 0 0 6.385 6.689Q18.77 45 24 45q5.227 0 11.545-.552a7 7 0 0 0 6.385-6.677q.07-1.656.07-3.803 0-5.765-.505-9.939a5 5 0 0 0-4.46-4.373q-.517-.052-1.035-.1V15c0-6.627-5.373-12-12-12S12 8.373 12 15m12 6q6.466 0 12.834.646a3 3 0 0 1 2.675 2.624q.49 4.044.491 9.698a89 89 0 0 1-.068 3.718 5 5 0 0 1-4.561 4.77Q29.135 43 24 43q-5.138 0-11.375-.544a5 5 0 0 1-4.561-4.778A90 90 0 0 1 8 34.065q0-5.693.496-9.794a3 3 0 0 1 2.675-2.625Q17.537 21 24 21m-6 8a6 6 0 1 1 10 4.472V37a4 4 0 0 1-8 0v-3.528A6 6 0 0 1 18 29m4 4a1 1 0 0 0-.4-.8 4 4 0 1 1 4.799 0A1 1 0 0 0 26 33v4a2 2 0 1 1-4 0zm-2-13.939V15a4 4 0 0 1 8 0v4.061a131 131 0 0 0-8 0M30 15v4.138q2.005.093 4 .247V15c0-5.523-4.477-10-10-10S14 9.477 14 15v4.385a129 129 0 0 1 4-.247V15a6 6 0 0 1 12 0",
      clipRule: "evenodd"
    }
  )
);
var SvgLockedOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var LockedOutlined_default = SvgLockedOutlined;

export { LockedOutlined_default as default };
